module.exports = __webpack_public_path__ + "fonts/NespressoLucas-BoldItalic.eot?v=48d40ef89e374196ee7f27ac2d8474e0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/nespresso-lucas/NespressoLucas-BoldItalic.eot?
// module id = 645
// module chunks = 0